import { GridApi } from 'ag-grid-community';
import { CommonUtil } from './common-util';

export class AgGridUtil {
  public static getGridFilterModel(api: any): any {
    const filterModel = api.getFilterModel();
    // copy required: if not, original object is modified
    return this.setFilterFixGet(filterModel);
  }

  public static setGridFilterModel(api: any, filterModel: any, force = false): boolean {
    const currentModel = this.getGridFilterModel(api);

    // check if out of sync, trigger filter change on force...
    if (!force && CommonUtil.isDeepEqual(currentModel, filterModel)) {
      return false;
    }

    api.setFilterModel(this.setFilterFixSet(filterModel));
    return true;
  }

  public static setFilterFixGet(filterModel: any): any {
    // copy required: if not, original object is modified
    const copy = JSON.parse(JSON.stringify(filterModel));
    this.fix(copy, false);
    return copy;
  }

  public static setFilterFixSet(filterModel: any): any {
    // copy required: if not, original object is modified
    const copy = JSON.parse(JSON.stringify(filterModel));
    this.fix(copy, true);
    return copy;
  }

  public static isFilterModelInSync(api: GridApi, filterModel: any): boolean {
    const currentModel = this.getGridFilterModel(api);
    return CommonUtil.isDeepEqual(currentModel, filterModel);
  }

  public static isEqualFilterModel(oldValue: any, newValue: any): boolean {
    if (oldValue == null || newValue == null) return oldValue === newValue;

    const keys = Object.keys(oldValue);
    if (JSON.stringify(keys.sort()) !== JSON.stringify(Object.keys(newValue).sort())) return false;

    for (const key of keys) {
      if (!this.isEqualSingleFilter(oldValue[key], newValue[key])) {
        return false;
      }
    }
    return true;
  }

  public static isEqualSingleFilter(oldValue: any, newValue: any): boolean {
    if (oldValue.filterType !== newValue.filterType) {
      return false;
    }

    if (oldValue.operator !== newValue.operator) {
      return false;
    }

    switch (oldValue.filterType) {
      case 'text':
      case 'number':
        if (oldValue.operator) {
          return (
            this.isEqualSingleFilter(oldValue.condition1, newValue.condition1) &&
            this.isEqualSingleFilter(oldValue.condition2, newValue.condition2)
          );
        } else {
          return oldValue.type === newValue.type && oldValue.filter === newValue.filter;
        }
      case 'set':
        return CommonUtil.isArrayEqual(oldValue.values, newValue.values);
    }
  }

  private static fix(filterModel: any, write: boolean) {
    // set filters: value arrays are extracted as string[] -> convert back to numer[]
    if (filterModel && Object.keys(filterModel).length !== 0) {
      Object.keys(filterModel).forEach(prop => {
        const field = filterModel[prop];
        if (field.values) {
          field.values = write ? field.values.map(o => o?.toString()) : this.readDomainValueFix(field.values);
        }
      });
    }
  }

  private static readDomainValueFix(values: any) {
    if (Array.isArray(values) && values.length > 0 && /^\d+$/.test(values[0]) === false) {
      return values; // treat as string
    }
    return values.map(Number);
  }
}
